<template>
  <div class="event-sign">
    <div class="head-nav">
      <!--<div class="rt_pos" @click="goback()"></div>-->
      <p>{{ title }}</p>
    </div>
    <div
      class="container"
      :class="{ active: type == 'succeed' || type == 'overdue' }"
      v-if="type == 'succeed' || type == 'overdue' || type == 'exist'"
    >
      <div class="state">
        <img :src="errorImg" alt="" />
        <p class="succeed">{{ msg }}</p>
      </div>
    </div>
    <div class="container" v-else>
      <div class="state">
        <img :src="errorImg" alt="" />
        <p class="failed">{{ msg }}</p>
      </div>
      <div class="event-info">
        <div class="title">
          <p>{{ baseInfo ? baseInfo.eventName : "" }}</p>
          <div class="desc-content"></div>
        </div>
        <div class="event-list">
          <ul>
            <li>
              <label>Date:</label>
              <p>{{ baseInfo ? baseInfo.trainingDate : "" }}</p>
            </li>
            <li>
              <label>Time:</label>
              <p>{{ baseInfo ? baseInfo.trainingTime : "" }}</p>
            </li>
            <li>
              <label>Trainer Name:</label>
              <p>{{ baseInfo ? baseInfo.trainerName : "" }}</p>
            </li>
            <li>
              <label>Speaker Name:</label>
              <p>{{ baseInfo ? baseInfo.speakerName : "" }}</p>
            </li>
            <li>
              <label>Type of Training:</label>
              <p>{{ baseInfo ? baseInfo.trainingType : "" }}</p>
            </li>
            <li class="details" :class="{ active: online }">
              <label>Venue Details:</label>
              <p>{{ venueDetails }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="online" v-if="online">
      <p @click="onlineLeave(onlineUrl)">Access to online meeting room</p>
    </div>
  </div>
</template>
<script>
import utils from "../assets/js/utils";
export default {
  name: "eventSign",
  data() {
    return {
      title: "Succeed",
      msg: "",
      errorImg: require("../assets/img/icon_error.png"),
      type: "", //0是overdue已经签到过,1是succeed签到成功,2是failed活动过期，3cancel取消的活动，4cancel关闭活动 5、notStart没开始 6、表示注册人数超过了限制
      baseInfo: [],
      venueDetails: "",
      online: false,
      isClear: false,
      onlineUrl: "",
    };
  },
  created() {
    let type = this.$route.query.type;
    if (
      type == "failed" ||
      type == "notStart" ||
      type == "close" ||
      type == "cancel" ||
      type == "limit"
    ) {
      this.getDetailList(utils.GetQueryString("EventID"));
    }
    if (document.body.getElementsByClassName("grecaptcha-badge").length > 0) {
      this.removeScript(
        "https://www.recaptcha.net/recaptcha/api.js?hl=en&render=6LcW68kUAAAAACekIXGnKkBdJscr5EyqOvBsurJg"
      );
      document.body.getElementsByClassName("grecaptcha-badge")[0].remove();
    }
  },
  mounted() {
    this.type = this.$route.query.type;
    switch (this.$route.query.type) {
      case "succeed":
        this.title = "Succeed";
        this.msg = "Thank you for your registration";
        this.errorImg = require("../assets/img/icon_succeed.png");
        this.online = this.$route.query.onlinetype;
        this.onlineUrl = this.$route.query.url;
        let succeed = window.utag_data;
        window.utag_data["page_name"] = "Thank you for your registration";
        window.utag.view(succeed);
        break;
      case "overdue":
        this.title = "Succeed";
        this.msg = "You have already registered for the training";
        this.errorImg = require("../assets/img/icon_succeed.png");
        this.online = this.$route.query.onlinetype;
        this.isClear = this.$route.query.isClear;
        this.onlineUrl = this.$route.query.url;
        let overdue = window.utag_data;
        window.utag_data["page_name"] =
          "You have already registered for the activity";
        window.utag.view(overdue);
        break;
      case "failed":
        this.title = "Fail";
        this.msg = "Training expired";
        this.errorImg = require("../assets/img/icon_error.png");
        let expired = window.utag_data;
        window.utag_data["page_name"] = "Training expired";
        window.utag.view(expired);
        break;
      case "cancel":
        this.title = "Fail";
        this.msg = "Training cancelled";
        this.errorImg = require("../assets/img/icon_error.png");
        let cancel = window.utag_data;
        window.utag_data["page_name"] = "Training cancelled";
        window.utag.view(cancel);
        break;
      case "close":
        this.title = "Fail";
        this.msg = "Training closed";
        this.errorImg = require("../assets/img/icon_error.png");
        let closed = window.utag_data;
        window.utag_data["page_name"] = "Training not yet started";
        window.utag.view(closed);
        break;
      case "notStart":
        this.title = "Fail";
        this.msg = "Training not yet started";
        this.errorImg = require("../assets/img/icon_error.png");
        let started = window.utag_data;
        window.utag_data["page_name"] = "Training not yet started";
        window.utag.view(started);
        break;
      case "exist":
        this.title = "Fail";
        this.msg = "Activity doesn't exist";
        this.errorImg = require("../assets/img/icon_error.png");
        let exist = window.utag_data;
        window.utag_data["page_name"] = "Activity does not exist";
        window.utag.view(exist);
        break;
      case "limit":
        this.title = "Fail";
        this.msg =
          "Sorry for that you failed to register, due to this training has reached maximum capacity.";
        this.errorImg = require("../assets/img/icon_error.png");
        let limit = window.utag_data;
        window.utag_data["page_name"] = "The enrollment limit was exceeded";
        window.utag.view(limit);
        break;
      default:
        break;
    }
  },
  //使用组件内守卫，对离开页面事件做一些操作，
  beforeRouteLeave(to, from, next) {
    if (!!this.onlineUrl) {
      next(true);
    } else {
      next(false);
    }
  },
  methods: {
    //移除script
    removeScript(src) {
      var scripts = document.getElementsByTagName("script");
      for (var i = 0; i < scripts.length; i++) {
        if (scripts[i] && scripts[i].src && scripts[i].src.indexOf(src) != -1) {
          scripts[i].parentNode.removeChild(scripts[i]);
        }
      }
    },
    //获取活动信息
    getDetailList(id) {
      let params = {
        EventID: id,
      };
      this.showloading("Loading");
      this.axios.getDetailInfo(params).then((res) => {
        this.hideloading();
        if (res.resultCode == 1) {
          this.baseInfo = res;
          if (res.venueType == "Online" || res.venueType == "ONLINE") {
            this.venueDetails = "Online meeting";
          } else {
            this.venueDetails = res.venueDetails;
          }
        } else {
          this.diolog(res.resultMsg);
        }
      });
    },
    //返回上一层
    goback() {
      this.$router.go(-1);
    },
    //跳转
    onlineLeave(url) {
      window.location.href = url;
    },
  },
};
</script>
<style lang="less" scoped>
.event-sign {
  position: relative;
  .online {
    p {
      cursor: pointer;
      color: blue;
      font-size: 14px;
      text-decoration: underline;
    }
  }
  .head-nav {
    background-color: #002f5f;
    text-align: center;
    line-height: 45px;
    position: relative;
    height: 45px;
    .rt_pos {
      position: absolute;
      left: 10px;
      top: 15px;
      content: "";
      display: inline-block;
      height: 11px;
      width: 11px;
      border-width: 0 0 1.5px 1.5px;
      border-color: #fff;
      border-style: solid;
      transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
      -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
      /*上箭头：border-width: 2px 0 0 2px;*/
      /*右箭头：border-width: 2px 2px 0 0;*/
      /*下箭头：border-width: 0 2px 2px 0;*/
      /*左箭头：border-width: 0 0 2px 2px;*/
    }
    p {
      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
    }
  }
  .container.active {
    margin-top: 150px;
  }
  .container {
    padding: 0 10px;
    .state {
      margin: 40px auto 38px;
      img {
        width: 50px;
        height: 50px;
      }
      p {
        font-size: 20px;
        color: #f5a623;
        letter-spacing: 0;
        line-height: 28px;
        margin-top: 8px;
        font-family: PingFangTC-Medium;
      }
      p.succeed {
        color: #19c66e;
        padding: 0 10px;
      }
      p.failed {
        color: #f5a623;
      }
    }
    .event-info {
      background-color: white;
      border: 1px solid #e3e3e3;
      padding: 20px 0px 0px;
      .title {
        display: flex;
        flex-direction: column;
        padding: 0 22px;
        text-align: left;
        .desc-content {
          width: 20px;
          height: 5px;
          background: #ed174c;
          margin-top: 6.5px;
        }
        p {
          font-size: 18px;
          color: #002f5f;
          letter-spacing: 0;
          line-height: 28px;
          font-family: PingFangTC-Medium;
        }
      }
      .event-list {
        padding: 11px 22px;
        ul {
          overflow: hidden;
          li.details {
            flex-direction: column;
            margin-bottom: 0px;
            p {
              text-align: left;
              margin-left: 0px;
              margin-bottom: 10px;
              margin-top: 10px;
            }
          }
          li.details.active {
            flex-direction: row;
            p {
              text-align: right;
              margin-left: 0px;
              margin-top: 0px;
            }
          }
          li {
            display: flex;
            flex-direction: row;
            align-items: self-end;
            margin-bottom: 10px;
            label {
              display: block;
              text-align: left;
              font-size: 14px;
              color: #929292;
              letter-spacing: 0;
              line-height: 20px;
              min-width: 105px;
              font-family: PingFangSC-Medium;
            }
            p {
              font-size: 14px;
              color: #1a1a1a;
              letter-spacing: 0;
              line-height: 20px;
              margin-left: 15px;
              text-align: right;
              flex: 1;
              font-family: PingFangTC-Regular;
            }
          }
        }
      }
    }
  }
  .register-btn {
    height: 48px;
    line-height: 48px;
    position: absolute;
    bottom: 53px;
    left: 0;
    width: 100%;
    .space {
      padding: 0 48px;
      button {
        font-size: 15px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        width: 100%;
        padding: 0;
        background: #002f5f;
        font-family: PingFangSC-Medium;
      }
    }
  }
}
</style>
